import React from "react";
import "./Footer.css";
import NavLinks from "../Comman/Nav";
import Facebook from "../../Assets/Images/Footer/Facebook.svg";
import Instagram from "../../Assets/Images/Footer/Instagram.svg";
import Linkedin from "../../Assets/Images/Footer/LinkedIn.svg";
import Twitter from "../../Assets/Images/Footer/Twitter.svg";

const Footer = () => {
  return (
    <footer>
      <div className="footer_div1">
        <h3 className="footer_logo">نجيب محفوظ</h3>
        <ul className="footer_div2">
          <NavLinks text="الرئيسية" to="/" />
          <NavLinks text="من هو" to="/about" />
          <NavLinks text="أعماله الأدبية" to="/works" />
          <NavLinks text="الإنجازات" to="/achievements" />
        </ul>
        <div className="footer_div3">
          <img className="footer_icon" src={Facebook} alt="Facebook" />
          <img className="footer_icon" src={Instagram} alt="Instagram" />
          <img className="footer_icon" src={Linkedin} alt="LinkedIn" />
          <img className="footer_icon" src={Twitter} alt="Twitter" />
        </div>
      </div>
      <div className="divider"></div>
      <div className="footer_div4">
        <h6 className="footer_text">©2022, All rights reserved.</h6>
        <div className="footer_div5">
          <h6 className="footer_text">Samia Ahmed</h6>
          <h6 className="footer_text">Designed by</h6>
        </div>
      </div>
    </footer>
  );
};

export default Footer;